export default __webpack_public_path__ + "static/media/bell-line.471ccb9a.svg";